import React, { PureComponent } from 'react';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { capitalize } from 'lodash-es';

import { BaseInputProps } from '../types';
import { isExpired, isNullLike } from '../utils';

import { Expiries } from './Expiries';
import { Select } from 'antd';

export interface OneWayHandlerInfo {
  expiry: string;
  oneWayMode: string;
  optionType: string;
  offloadRisk: boolean;
}

export interface OneWayHandlerProps extends BaseInputProps {
  value?: OneWayHandlerInfo[];

  onChange?: (val: OneWayHandlerInfo[]) => void;

  options?: string[];
}

export class OneWayHandlerList extends PureComponent<OneWayHandlerProps> {
  value: OneWayHandlerInfo[] = [];

  isEmptyItem = (item: OneWayHandlerInfo) => {
    return (
      !item.expiry?.trim() &&
      isNullLike(item.oneWayMode) &&
      isNullLike(item.optionType) &&
      isNullLike(item.offloadRisk)
    );
  };

  onChange = (i: number, val: any, key?: keyof OneWayHandlerInfo) => {
    const value = [...this.value];
    if (!value[i])
      value[i] = {
        expiry: '',
        oneWayMode: '',
        optionType: 'Both',
        offloadRisk: false,
      };
    if (key) value[i][key] = val as never;
    else value[i] = { ...value[i], ...val };
    this.props.onChange?.(
      value.length === 1 && this.isEmptyItem(value[0]) ? [] : value,
    );
  };

  onAdd = (i: number) => {
    const value = [...this.value];
    value.splice(i + 1, 0, {
      expiry: '',
      oneWayMode: '',
      optionType: 'Both',
      offloadRisk: false,
    });
    this.props.onChange?.(value);
    this.props.onBlur?.();
  };

  onDel = (i: number) => {
    const value = [...this.value];
    value.splice(i, 1);
    this.props.onChange?.(
      value.length === 1 && this.isEmptyItem(value[0]) ? [] : value,
    );
    this.props.onBlur?.();
  };

  render() {
    this.value = this.props.value?.filter(it => !isExpired(it.expiry)) || [];

    // if (!this.value.length)
    //   this.value.push({
    //     expiry: '',
    //     oneWayMode: '',
    //     optionType: 'Both',
    //     offloadRisk: false,
    //   });
    return (
      <div
        className={classNames(
          this.props.className,
        )}
        style={this.props.style}
      >
        {this.props.readonly ? (
          this.props.value?.length ? (
            this.value
              .filter(it => it.expiry)
              .map((it, i) => (<>
                <span key={i}>
                  {it.expiry}
                  <span>/</span>
                  {!isNullLike(it.oneWayMode) ? it.oneWayMode : '-'}
                  <span>/</span>
                  {!isNullLike(it.optionType) ? it.optionType : '-'}
                  <span>/</span>
                  {it.offloadRisk !== undefined
                    ? capitalize(it.offloadRisk.toString())
                    : '-'}
                </span>
                <br />
                </>
              ))
          ) : (
            '-'
          )
        ) : (
          <div className="grid grid-cols-10 gap-4 w-full">
            <div className="font-medium text-gray-700 col-span-2 rounded-md">Expiry</div>
            <div className="font-medium text-gray-700 col-span-2 rounded-md">OneWayMode</div>
            <div className="font-medium text-gray-700 col-span-2 rounded-md">Option Type</div>
            <div className="font-medium text-gray-700 col-span-2 rounded-md">OffloadRisk</div>
            {this.value.length > 0 ? <div className=' col-span-2' /> : <div className="col-span-2 flex space-x-2">
                  <PlusOutlined
                    className="p-1 rounded hover:bg-blue-100 transition-colors"
                    onClick={this.onAdd.bind(null, 0)}
                  />
                </div>}
            {this.value.map((it, i) => (
              <React.Fragment key={i}>
                <Expiries
                  style={{ width: 110, minWidth: 0 }}
                  multiple={false}
                  options={this.props.options}
                  value={[it.expiry]}
                  onChange={val => this.onChange(i, val[0], 'expiry')}
                  // calcDisabled={(expiry) =>
                  //   this.value.some((item) => item !== it && item.expiry === expiry)
                  // }
                  onBlur={this.props.onBlur}
                  className=' col-span-2'
                />
                <Select
                  value={[it.oneWayMode || '']}
                  onChange={val => this.onChange(i, val, 'oneWayMode')}
                  options={['BidOnly', 'AskOnly'].map(it => ({ label: it, value: it }))}
                  className=' col-span-2'
                />
                <Select
                  value={[it.optionType || '']}
                  onChange={val => this.onChange(i, val, 'optionType')}
                  options={['Both', 'Call', 'Put'].map(it => ({ label: it, value: it }))}
                  className=' col-span-2'
                />
                <Select
                  value={[it.offloadRisk  === true ? 'True' : it.offloadRisk === false ? 'False' : '']}
                  onChange={val =>
                    this.onChange(
                      i,
                      val,
                      'offloadRisk',
                    )
                  }
                  options={['True', 'False'].map(it => ({ label: it, value: it === 'True' ? true : false }))}
                  className=' col-span-2'
                />
                <div className="col-span-2 flex space-x-2">
                  <PlusOutlined
                    className="p-1 rounded hover:bg-blue-100 transition-colors"
                    onClick={this.onAdd.bind(null, i)}
                  />
                  <DeleteOutlined
                  className="p-1 rounded hover:bg-blue-100 transition-colors"
                    onClick={this.onDel.bind(null, i)}
                  />
                </div>
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    );
  }
}
